module.exports = __webpack_public_path__ + "static/media/primary.2b7fc95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/primary.png
// module id = 245
// module chunks = 0